import { AxiosError, AxiosResponse } from "axios"
import { useMutation } from "react-query"

import contentService from "api/contentService"
import { IUpdateTypeContentBodyParams } from "types/content"
import { useUI } from "providers/UIProvider"
import { RESPONSE_MODAL_VARIANTS } from "components/shared/modals/ResponseModal/ResponseModalTypes"
import { toast } from "react-toastify"

interface IUseUpdateTypeContent {
  data: IUpdateTypeContentBodyParams
} 

const useUpdateTypeContent = () => {
  const { toggleModal } = useUI()
  return useMutation(async ({ data }: IUseUpdateTypeContent) => {
      const res: AxiosResponse<any> = await contentService.updateTypeContent(data)

      return res.data
  }, {
    onSuccess: () => {
      toggleModal("responseModal", true, { variant: RESPONSE_MODAL_VARIANTS.SUCCESS })
      setTimeout(()=>toggleModal("responseModal", false), 3000)
    },
    onError: (err: AxiosError) => {
      if(err.response?.status !== 500) {
        toast.error("Internal Server Error")
      }
    }
  })
}

export default useUpdateTypeContent